import SalePublicPageBodyAdZone from "./SalePublicPageBodyAdZone";

export default {
    'sp_1_1': SalePublicPageBodyAdZone,
};